export enum DamageType {
  Mastarea = 'mastbereich',
  Span = 'spannfeld',
}
